import React from 'react';
import styled from 'styled-components';

import Chart from '../Chart';
import Statistic from '../Statistics';

const defaultConfig = {
  // width: 180,
  // height: 160,
  rangeSize: 13,
  pivot: {
    visible: true,
    thickness: 4,
    pointer: {
      visible: true,
      style: {
        fill: "#104663"
      }
    },
    base: {
      size: 15
    },
    pin: {
      visible: true,
      style: { fill: "#e8e6ea" }
    }
  },
  axis: {
    label: { visible: false },
  },
  rangeBackgroundStyle: {
    fill: '#DAE0E6',
  },
  label: {},
};

const PersonCphGauge = ({ value, max, statProps = {}, config = {} }) => {
  const hasValue = typeof value !== 'undefined';
  const hasMax = typeof max !== 'undefined';

  let val, maxVal, colors;
  if (hasValue && hasMax) {
    maxVal = Math.round(max);
    val = Math.round(Math.min(value, maxVal));
    colors = ['#EA6023', '#DF9522', '#9FAA18', '#6cc11b'];
  } else {
    maxVal = 12;
    val = 0;
    colors = ['#DAE0E6', '#DAE0E6', '#DAE0E6', '#DAE0E6'];
  }

  const piece = Math.floor(maxVal / 4);
  const ranges = Array.from((new Array(5)).keys()).map((_, i) => Math.floor(piece * i));
  ranges[ranges.length - 1] = Math.floor(maxVal);
  
  config = Object.assign({}, defaultConfig, config, {
    value: val,
    min: 0,
    max: maxVal,
    rangeSize: 10,
    range: ranges,
    color: colors,
    axis: {
      offset: -1,
      tickLine: { visible: false },
      label: { visible: true },
    },
  });

  if (typeof config.width === 'number') {
    config.rangeSize = Math.floor(config.width / 17);
    config.label.style = { fontSize: 45, fill: 'red' };
  }

  return (
    <PersonCphGaugeWrapper>
      <Chart type="metergauge" config={config} />
      <Statistic
        title="CPH/Person"
        value={hasValue ? Math.round(value) : 'N/A'}
        titleAlign={['center', 'bottom']}
        {...statProps}
      />
    </PersonCphGaugeWrapper>
  );
};

const PersonCphGaugeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default PersonCphGauge;
